import actions from '../actions';
import { APP_INIT, CURRENCY_CODE_CHANGE } from '../actionTypes';

const handleCurrencyCode = (storage, beforeState, afterState, action, store) => {
  if (action.type === APP_INIT) {
    store.dispatch(actions.currencyCodeLoaded(storage.get('currencyCode') || afterState.currencyExchangeRates.currencyCode));
  }
  if (action.type === CURRENCY_CODE_CHANGE) {
    storage.set('currencyCode', action.currencyCode);
  }
};

export default handleCurrencyCode;



// WEBPACK FOOTER //
// ./src/middleware/currencyCodePersistence.js